import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu as MenuIcon, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SITE } from "../data/site";

const linkClass = ({ isActive }) =>
  `font-heading text-sm font-bold transition-colors hover:text-bumbu ${
    isActive ? "text-bumbu" : "text-charcoal"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-amber-900/10 bg-canvas/90 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <Link to="/" aria-label="Beranda Ayam Goreng Bandung Bu Iyin" data-testid="logo-link" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav aria-label="Navigasi utama" className="hidden items-center gap-7 md:flex">
          {NAV.map((item) => (
            <NavLink key={item.href} to={item.href} end={item.href === "/"} className={linkClass} data-testid={item.testid}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={SITE.grabfood}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-grabfood-button"
            className="hidden rounded-full bg-goang px-5 py-2.5 font-heading text-sm font-bold text-white transition-all hover:scale-[1.03] hover:bg-goang-deep active:scale-[0.98] sm:inline-flex"
          >
            Pesan GrabFood
          </a>
          <button
            type="button"
            data-testid="mobile-menu-toggle"
            aria-expanded={open}
            aria-label={open ? "Tutup menu navigasi" : "Buka menu navigasi"}
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-amber-900/15 bg-white text-charcoal transition-colors hover:bg-bumbu-light md:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <MenuIcon className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="Navigasi seluler"
          data-testid="mobile-menu"
          className="border-t border-amber-900/10 bg-canvas px-5 pb-6 pt-2 md:hidden"
        >
          <ul className="flex flex-col">
            {NAV.map((item) => (
              <li key={item.href}>
                <NavLink
                  to={item.href}
                  end={item.href === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${item.testid}`}
                  className={({ isActive }) =>
                    `block border-b border-dashed border-amber-900/15 py-4 font-heading text-base font-bold ${
                      isActive ? "text-bumbu" : "text-charcoal"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="pt-4">
              <a
                href={SITE.grabfood}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-grabfood-button"
                className="block rounded-full bg-goang px-5 py-3 text-center font-heading text-sm font-bold text-white"
              >
                Pesan via GrabFood
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};
